// questionnaire-errors.data.ts
//
// Patient questionnaires.

import { ErrorEntry } from './error-metadata.types';

export const questionnaireErrors = {
  'answer-required': {
    message: 'Some required questions have not been answered. Please check your answers.',
    title: 'Your questionnaire could not be sent',
    redirectToError: false,
  },
  'invalid-answer-option': {
    message: 'One of your answers was not recognised. Please check your answers and try again.',
    title: 'Your questionnaire could not be sent',
    redirectToError: false,
  },
  'invalid-answer-type': {
    message: 'One of your answers was not in the expected format. Please check your answers.',
    title: 'Your questionnaire could not be sent',
    redirectToError: false,
  },
  'questionnaire-version-not-found': {
    message:
      'This questionnaire has been updated since it was sent to you, so your answers could not be saved. Please contact the surgery.',
    title: 'Your questionnaire could not be sent',
    showBackButton: false,
  },
  'questionnaire-not-found': {
    message:
      'This questionnaire link is not valid, or it was not sent to you. Check the link in your message.',
    title: 'We cannot find this questionnaire',
    showBackButton: false,
  },
  'questionnaire-already-completed': {
    message: 'This questionnaire has already been completed, so it cannot be filled in again.',
    title: 'This questionnaire is already complete',
    showBackButton: false,
  },
} satisfies Record<string, ErrorEntry>;
